// SPDX-FileCopyrightText: 2025 Slant Tech LLC
// SPDX-License-Identifier: GPL-3.0-or-later

function LoadingScreen() {
  return (
    <div className="min-h-screen bg-st-primary flex items-center justify-center">
      <div className="text-center">
        {/* Animated logo */}
        <div className="relative mb-6">
          <svg viewBox="0 0 100 100" className="w-24 h-24 mx-auto">
            {/* Outer border - animated */}
            <rect
              x="5"
              y="5"
              width="90"
              height="90"
              fill="rgb(var(--st-bg-secondary))"
              stroke="#FF6600"
              strokeWidth="3"
              className="animate-pulse"
            />

            {/* PCB traces - animated */}
            <g fill="#FF6600" className="animate-pulse">
              <rect x="20" y="35" width="25" height="3">
                <animate attributeName="opacity" values="0.3;1;0.3" dur="1.5s" repeatCount="indefinite" />
              </rect>
              <rect x="55" y="35" width="25" height="3">
                <animate attributeName="opacity" values="0.3;1;0.3" dur="1.5s" repeatCount="indefinite" begin="0.2s" />
              </rect>
              <rect x="20" y="62" width="25" height="3">
                <animate attributeName="opacity" values="0.3;1;0.3" dur="1.5s" repeatCount="indefinite" begin="0.4s" />
              </rect>
              <rect x="55" y="62" width="25" height="3">
                <animate attributeName="opacity" values="0.3;1;0.3" dur="1.5s" repeatCount="indefinite" begin="0.6s" />
              </rect>
              <rect x="48" y="20" width="3" height="20">
                <animate attributeName="opacity" values="0.3;1;0.3" dur="1.5s" repeatCount="indefinite" begin="0.3s" />
              </rect>
              <rect x="48" y="60" width="3" height="20">
                <animate attributeName="opacity" values="0.3;1;0.3" dur="1.5s" repeatCount="indefinite" begin="0.5s" />
              </rect>
            </g>

            {/* IC chip */}
            <rect x="35" y="40" width="30" height="20" fill="#1A1614" />

            {/* IC pins */}
            <g fill="#FF6600" opacity="0.6">
              <rect x="35" y="43" width="4" height="3" />
              <rect x="35" y="49" width="4" height="3" />
              <rect x="35" y="55" width="4" height="3" />
              <rect x="61" y="43" width="4" height="3" />
              <rect x="61" y="49" width="4" height="3" />
              <rect x="61" y="55" width="4" height="3" />
            </g>
          </svg>
        </div>

        <h1 className="text-xl font-display font-semibold mb-2">KiCad Review App</h1>

        <div className="flex items-center justify-center gap-2 text-st-muted">
          <div className="spinner" />
          <span className="font-body">Loading merge request...</span>
        </div>
      </div>
    </div>
  );
}

export default LoadingScreen;
